import React from 'react'
import styled from 'styled-components'

import {
  TableHead,
  TableHeaderStyle,
  TableStyle,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
} from './Table.styles'

type TableHeaderProps = React.PropsWithChildren<{
  className?: string
}>

const TableHeader = styled(function TableHeader(props: TableHeaderProps) {
  const { className, children } = props

  return (
    <TableHead className={className}>
      <TableHeaderStyle>{children}</TableHeaderStyle>
    </TableHead>
  )
})``

type TableComponentProps = React.PropsWithChildren<{
  className?: string
  evenColumns?: boolean
  hideHeader?: boolean
}>

const TableComponent = styled(function TableComponent(
  props: TableComponentProps
) {
  const { className, children, evenColumns, hideHeader } = props

  return (
    <TableStyle
      className={className}
      $evenColumns={evenColumns}
      $hideHeader={hideHeader}>
      {children}
    </TableStyle>
  )
})``

interface TableHeaderItem {
  label: React.ReactNode
  customCell?: React.ComponentType
}

interface TableProps<T extends any> extends TableComponentProps {
  header: TableHeaderItem[]
  items: T[]
  renderItem: (item: T) => React.ReactNode
  renderItemKey?: (item: T) => string | undefined
}

function Table<T extends any>(props: TableProps<T>) {
  const { header, items, renderItem, renderItemKey, ...tableProps } = props

  return (
    <TableComponent {...tableProps}>
      <TableHeader>
        {header.map(
          ({ label, customCell: TableCell = TableHeaderCell }, index) => (
            <TableCell key={index}>{label}</TableCell>
          )
        )}
      </TableHeader>
      <TableBody>
        {items.map((item, index) => (
          <React.Fragment key={renderItemKey?.(item) || index}>
            {renderItem(item)}
          </React.Fragment>
        ))}
      </TableBody>
    </TableComponent>
  )
}

export const TableComponents = {
  Table: TableComponent,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
}

export default Table
